import { observer } from "mobx-react";
import { FC } from "react";

import { useTranslation } from "../../stores/RootStoreContext";
import { MSelect } from "../../components-v2/Select";
import { Box, VBox } from "../../components-v2/Box";
import { LinkButton } from "../../components-v2/Button";
import { MCheckboxGroup } from "../../components-v2/Checkbox";
import { OptionFieldModel, RadioFieldModel } from "../../common/commonForms";
import { PortfolioCompany } from "../../stores/PortfolioStore";
import { Alert } from "../../components-v2/Alert";
import {
  CompanySelectorContextOption,
  CompanySelectorContextType,
} from "./portfolioCompanySelectorDomain";

export const PortfolioCompanySelector: FC<{
  title: string;
  companySelectorContext: RadioFieldModel<CompanySelectorContextOption | null>;
  companies: OptionFieldModel<PortfolioCompany>;
}> = observer(({ title, companySelectorContext, companies }) => {
  const { t } = useTranslation();
  return (
    <VBox gap={"md"}>
      <MSelect
        icon={"suitcaseSimple"}
        label={title}
        model={companySelectorContext}
        disabled={companySelectorContext.options.length === 1}
        tooltip={
          companySelectorContext.options.length === 1
            ? t("shareholders.exportCompanies.tooltip")
            : undefined
        }
      />
      {companySelectorContext.value?.type !== CompanySelectorContextType.COMPANY && (
        <>
          <Box>
            <LinkButton
              label={t(companies.isAllSelected ? "select-none" : "select-all")}
              onClick={() => companies.toggleAll(!companies.isAllSelected)}
            />
          </Box>
          <MCheckboxGroup model={companies} />
          {companies.isNoneSelected && (
            <Alert message={t("shareholders.exportCompanies.warning")} type={"warning"} />
          )}
        </>
      )}
    </VBox>
  );
});
